import { Header, Paragraph } from "components/atoms/Typography";
import "./NoDataState.scss";

interface NoDataStateProps {
    height?: number;
    title: string;
    component?: string;
}

function NoDataState({ height, title, component }: NoDataStateProps) {
    return (
        <div className="no-data-state" style={height ? { height: `${height}px` } : undefined}>
            <Header size="small">
                {title} {component}
            </Header>

            <Paragraph size="small" style={{ color: "var(--audette-gray-500)" }}>
                There is no data to display for this {component}
            </Paragraph>
        </div>
    );
}

interface ChartNoDataStateProps {
    title: string;
    component?: string;
}

export function ChartNoDataState({ title, component = "chart" }: ChartNoDataStateProps) {
    return <NoDataState height={450} title={title} component={component} />;
}

interface CardNoDataStateProps {
    title: string;
}

export function CardNoDataState({ title }: CardNoDataStateProps) {
    return <NoDataState height={150} title={title} component="card" />;
}
